const Banner = () => {
  let image = require("../assets/img/banner.jpg");
  return (
    <div className="banner">
      <img
        key="banner-img"
        src={image}
        alt="banner-img"></img>
    </div>
  );
};

export default Banner;
